import { Button, Dialog, Portal, Text, VStack } from '@chakra-ui/react'
import { useState } from 'react'
import { toast } from '@/components/ui/toaster/toasterHelpers'
import { deleteBank } from '@/api/settings.api'

interface DeleteBankDialogProps {
  isOpen: boolean
  onClose: () => void
  bankId: number
  onDeleted: () => void
}

function translateDeleteBankError(err: any) {
  const code = err?.code || err?.response?.data?.code
  const msg = (
    err?.backendMessage ||
    err?.message ||
    err?.response?.data?.message ||
    ''
  ).toString()

  if (code === 'CONFLICT') {
    const m = msg.toLowerCase()
    if (m.includes('activities')) {
      return 'Auftraggeber kann nicht gelöscht werden, weil bereits Aktivitäten damit verknüpft sind.'
    }
    if (m.includes('invoices')) {
      return 'Auftraggeber kann nicht gelöscht werden, weil bereits Rechnungen damit verknüpft sind.'
    }
    return 'Auftraggeber kann nicht gelöscht werden, weil bereits Daten damit verknüpft sind.'
  }

  return 'Auftraggeber konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.'
}

export function DeleteBankDialog({ isOpen, onClose, bankId, onDeleted }: DeleteBankDialogProps) {
  const [loading, setLoading] = useState(false)

  const handleDelete = async () => {
    setLoading(true)
    try {
      await deleteBank(bankId)
      toast.success('Auftraggeber wurde gelöscht.')
      onClose()
      onDeleted()
    } catch (err: any) {
      toast.error('Auftraggeber konnte nicht gelöscht werden', translateDeleteBankError(err))
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={d => !d.open && onClose()}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Auftraggeber löschen</Dialog.Title>
              <Dialog.CloseTrigger />
            </Dialog.Header>

            <Dialog.Body>
              <VStack align="start" gap={3}>
                <Text>
                  Der Auftraggeber und alle zugeordneten, noch nicht abgerechneten Aktivitäten
                  werden gelöscht. Dieser Vorgang kann nicht rückgängig gemacht werden.
                </Text>
              </VStack>
            </Dialog.Body>
            <Dialog.Footer>
              <Button variant="ghost" onClick={onClose}>
                Abbrechen
              </Button>
              <Button colorPalette="red" loading={loading} onClick={handleDelete}>
                Auftraggeber löschen
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
